import { Pipe, PipeTransform } from '@angular/core';

/** Returns whether the category is hidden or not. */
@Pipe({ name: 'isHiddenCategory' })
export class IsHiddenCategoryPipe implements PipeTransform {
	/** Whether the category is hidden or not. */
	transform(category: api.CategoryDto, allCategories: api.CategoryDto[]): boolean {
		if (typeof category !== 'object' || !Array.isArray(allCategories) || allCategories.length === 0)
			return false;
		if (category.status === 'hidden') return true;
		// Check all parents for hidden categories
		let parentPath = this.getParentPath(category.path);
		while (parentPath) {
			const parent = allCategories?.find((cat) => {
				return cat.path === parentPath;
			});
			if (!parent) return false;
			if (parent.status === 'hidden') return true;
			parentPath = this.getParentPath(parent.path);
		}
		return false;
	}

	/** Returns the parent path of the given path. */
	private getParentPath(path: string): string {
		const parts = path.split('.');
		parts.splice(-1, 1);
		return parts.length > 1 ? parts.join('.') : undefined;
	}
}
